import { Card, CardContent, CardHeader, Grid, makeStyles, Tooltip, Typography } from '@material-ui/core';
import React, { useState } from 'react';
import { FaEye } from 'react-icons/fa';
import DashboardLoading from './DashboardLoading';

const classStyle = makeStyles(() => ({
  header: {
    fontSize: '16px',
  },
  hr: {
    color: '#D6CFCF',
  },
  content: {
    paddingRight: '10px !important',
    paddingBottom: '10px !important',
  },
  contentGrid: {
    minHeight: '60px',
  },
  subtitle: {
    fontSize: '12px',
  },
  tooltip: {
    maxWidth: 'none',
    fontSize: '12px',
  },
}));

const getCurrency = (value) =>
  new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' })
    .format(value)
    .replace('R$', '')
    .trim();

const Content = ({ valor, descricao, detalhes, classes, cor, noCurrency }) => {
  return (
    <>
      <Grid item xs={6}>
        <Typography variant="h4" style={{ color: cor }}>
          {noCurrency ? valor : getCurrency(valor || 0)}
        </Typography>
        <Typography className={`${classes.subtitle}`}>{descricao}</Typography>
      </Grid>

      <Grid item xs={6} container alignItems="flex-end" justify="flex-end">
        {detalhes && (
          <Tooltip title={detalhes} placement="right" classes={{ tooltip: classes.tooltip }}>
            <div>
              <FaEye size={20} />
            </div>
          </Tooltip>
        )}
      </Grid>
    </>
  );
};

const Dashboard = ({ titulo, valor, descricao, detalhes, cor, noCurrency, className }) => {
  const [loading] = useState(false);
  const classes = classStyle();

  return (
    <Card className={className}>
      <CardHeader
        title={
          <Grid container>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <Typography>{titulo}</Typography>
            </Grid>
          </Grid>
        }
        classes={{ title: classes.header }}
      />

      <hr className={classes.hr} />

      <CardContent className={`${classes.content}`}>
        <Grid container className={`${classes.contentGrid}`}>
          {loading ? (
            <DashboardLoading />
          ) : (
            <Content
              valor={valor}
              descricao={descricao}
              detalhes={detalhes}
              classes={classes}
              cor={cor}
              noCurrency={noCurrency}
            />
          )}
        </Grid>
      </CardContent>
    </Card>
  );
};

export default Dashboard;
